const DECLARED_ROLE_PRIORITY = ['admin', 'economist', 'dispatcher', 'fleet_manager', 'driver'];

const normalizeRoleCode = (role) => {
  if (typeof role === 'string') return role.trim().toLowerCase();
  if (!role || typeof role !== 'object') return '';

  return String(role.code || role.role || role.name || '').trim().toLowerCase();
};

const getDeclaredRole = (profile) => {
  const directRole = normalizeRoleCode(profile?.role);
  if (directRole) {
    return DECLARED_ROLE_PRIORITY.includes(directRole) ? directRole : 'user';
  }

  const listedRoles = Array.isArray(profile?.roles)
    ? new Set(profile.roles.map(normalizeRoleCode).filter(Boolean))
    : new Set();
  if (!listedRoles.size) return '';
  return DECLARED_ROLE_PRIORITY.find((role) => listedRoles.has(role)) || 'user';
};

export const isEconomistProfile = (profile) => {
  const declaredRole = getDeclaredRole(profile);
  return declaredRole ? declaredRole === 'economist' : profile?.is_economist === true;
};

export const getProfileRole = (profile) => {
  if (!profile) return 'user';
  const declaredRole = getDeclaredRole(profile);
  if (declaredRole) return declaredRole;
  if (profile.is_admin) return 'admin';
  if (profile.is_economist) return 'economist';
  if (profile.is_dispatcher) return 'dispatcher';
  if (profile.is_fleet_manager) return 'fleet_manager';
  if (profile.is_driver) return 'driver';
  return 'user';
};
